import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EntityService } from '@services/core/entity.service';
import { EditGroupComponent } from './editGroup/edit_group.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-groups',
	templateUrl: './groups.component.html',
	styleUrls: ["./groups.component.css"],
    imports: [CommonModule, NgbTooltipModule, PanelComponent, EditGroupComponent ],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class GroupComponent implements OnInit{
    protected groups
    protected group
    private groupsTemp
    protected showEditGroup = false
    private entityService = inject(EntityService)
    private destroyRef = inject(DestroyRef)

	ngOnInit(): void {
	    this.getGroups()
	}

    getGroups(){
        this.group = null
        this.showEditGroup = false
        this.entityService.getGroupsEntities().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.groups = res
            this.groupsTemp = res
        })
    }

    filtrarGrupos(valor: string) {
        if(valor.length > 0){
            this.groups = this.groupsTemp.filter((group: any) =>
                group.name.toLowerCase().includes(valor.toLowerCase()) ||
                group.acronym.toLowerCase().includes(valor)
            );
        }else{
            this.groups = this.groupsTemp
        }
    }

    addGroup(){
        this.group = null
        this.showEditGroup = true
    }

    setEditGroup(group: any){
        this.group = group
    }

    toggleGroup(group: any){
        group.enabled = !group.enabled
        this.entityService.updateGroup(group).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    }

    moveUp(i: number) {
        if (i === 0) return
        const item = this.groups[i]
        this.groups[i] = this.groups[i - 1]
        this.groups[i - 1] = item
        this.entityService.updateGroups(this.groups).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    }

    moveDown(i: number) {
        if (i === this.groups.length - 1) return
        const item = this.groups[i]
        this.groups[i] = this.groups[i + 1]
        this.groups[i + 1] = item
        this.entityService.updateGroups(this.groups).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    }
}
